// extracted by mini-css-extract-plugin
export default {"wrapper":"lp-z","response":"mp-z","error":"np-z","disabled":"op-z","buttons":"pp-z","feedbackQuestionSection":"qp-z","yesNoWrapper":"rp-z"};